import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { APP_HOME_PATH } from "../../config/routes";

import MilkDashboardPanel from "../../components/dashboard/MilkDashboardPanel";

export default function MilkDashboardPage() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link component={RouterLink} underline="hover" color="inherit" to={APP_HOME_PATH}>
          Dashboard
        </Link>
        <Typography color="text.primary">Milk dashboard</Typography>
      </Breadcrumbs>

      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
        Milk Dashboard
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        Track production, pricing, sales, and milk income from one dedicated view.
      </Typography>

      <MilkDashboardPanel />
    </Box>
  );
}
